import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { AppContext } from '@prisjakt/ui-app-context';
import ListItem from '@prisjakt/ui-list-item';
import Button from '@prisjakt/ui-button';
import PanelHeader from '@prisjakt/ui-panel-header';

import FilterPanel from './components/panel';
import FilterToggle from '../filter-toggle';

import filterActions from '../../actions/filter';

import * as S from './styles';

class Filter extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
    };
  }

  render() {
    const { expandedCategories } = this.props.filter;

    const { t } = this.context;

    const {
      inputValue,
      filteredCore,
      filteredSections,
      filteredValues,
      disabledExpansions,
    } = this.props.search;

    const isBrandedCategory = Boolean(this.props.brand);
    const isSearching = inputValue.length > 1;

    return (
      <>
        <S.Header>
          <PanelHeader divider="none" title={t('filter', 'filter.title')}>
            <FilterToggle
              toggleHorizontalFilter={this.props.toggleFilter}
              expanded={this.props.expanded}
            />
          </PanelHeader>
        </S.Header>

        {this.props.quickFilters.length > 0 && (
          <div>
            {this.props.quickFilters.map(c => (
              <ListItem
                key={c.name}
                name={c.name}
                link={c.pathName}
                showArrow
              />
            ))}
          </div>
        )}

        <S.Filter horizontal>
          <div>
            {filteredCore.map(coreFilter => (
              <FilterPanel
                key={coreFilter.id}
                layout="horizontal"
                canCompare={this.props.canCompare}
                compareLimit={8}
                isBrandFilteredCategory={isBrandedCategory}
                displayFilter={coreFilter}
                filteredValues={filteredValues}
              />
            ))}
          </div>
          <S.MoreFilters>
            <Button
              variant="text"
              color="link"
              onClick={() =>
                this.setState(prevState => ({ showAll: !prevState.showAll }))
              }
            >
              {t(
                'filter',
                !this.state.showAll
                  ? 'properties.quantity-show-more'
                  : 'properties.quantity-show-less'
              )}
            </Button>
          </S.MoreFilters>
          <div>
            {filteredSections.map(section => {
              const showSection =
                this.state.showAll || isSearching
                  ? disabledExpansions.indexOf(section.name) < 0 // Defaults to expanded
                  : expandedCategories.indexOf(section.name) >= 0; // Defaults to collapsed

              // Remove empty sections
              if (
                section.children.filter(
                  subFilter =>
                    (subFilter.item_type === 'category' &&
                      subFilter.children) ||
                    (filteredValues &&
                      filteredValues[subFilter.id] &&
                      filteredValues[subFilter.id].max_matching_products)
                ).length === 0
              ) {
                return null;
              }

              if (!showSection) {
                return null;
              }

              return (
                <FilterPanel
                  key={section.name}
                  layout="horizontal"
                  compareLimit={8}
                  name={section.name}
                  isBrandFilteredCategory={isBrandedCategory}
                  displayFilter={section}
                  filteredValues={filteredValues}
                  hideName
                />
              );
            })}
          </div>
        </S.Filter>
      </>
    );
  }
}

const { object, func, number, string, array, bool } = PropTypes;

Filter.propTypes = {
  category: object.isRequired,
  filter: object.isRequired,
  search: object.isRequired,
  brand: object,
  expandSection: func.isRequired,
  propertySearch: func.isRequired,
  propertySearchToggleExpansion: func.isRequired,
  toggleMobile: func.isRequired,
  filterQuery: func.isRequired,
  productCount: number,
  className: string,
  quickFilters: array.isRequired,
  canCompare: bool,
  toggleFilter: func.isRequired,
  expanded: bool,
};

Filter.defaultProps = {
  productCount: 0,
  className: '',
  brand: null,
  canCompare: true,
  expanded: false,
};

export default connect(
  state => state.areas.category,
  filterActions
)(withRouter(Filter));

Filter.contextType = AppContext;
